// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class FeeType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  amountBased!: boolean;
  defaultAmount!: number;
  deleted?: Date;
  displayOrder?: number;
  name?: string;
  percentageBased!: boolean;
  quickBooksInvoiceAccount?: string;
  quickBooksPaymentAccount?: string;
}

